<template>
  <div class="green-operation__status">
    <div
      v-if="canViewHistoricalRecords"
      class="green-operation__status-actions"
    >
      <a
        class="green-operation__history-link"
        @click="$emit('view-historical-records')"
      >
        {{ $t('tenancy.greenOperation.viewHistoricalHistory') }}
      </a>
    </div>
    <div class="green-operation__status-info row align-center">
      <div class="small-12 row">
        <div class="small-6">
          <label>{{ $t('tenancy.greenOperation.reviewStatus') }}</label>
          <div v-if="!isStarted">
            {{ currentStatus }}
          </div>
          <HKLStatusBadge
            v-else
            class="green-operation__status-value pointer"
            :value="currentStatus | uppercase"
            @click="openLifecycle"
          />
        </div>
        <div class="small-6">
          <label>{{ $t('tenancy.greenOperation.expiryDate') }}</label>
          <div>
            {{ expiryDateDisplay }}
          </div>
        </div>
      </div>
    </div>
    <HKLGrayHint
      v-if="!isStarted && isTenant"
      class="tenant-hint font-size-14"
    >
      {{ $t('tenancy.greenOperation.sustainabilityHint') }}
    </HKLGrayHint>
    <GreenOperationStatusLifecycle ref="modal" />
  </div>
</template>

<script>
import { computed, unref } from 'vue-demi'
import HKLStatusBadge from '@/controls/Badge/HKLStatusBadge.vue'
import HKLGrayHint from '@/controls/HKLGrayHint.vue'
import { useRefModal } from '@/controls/Modal/modal.hook'
import { useStoreGetters } from '@/store/index'
import dateUtil from '@/utils/dateUtil'
import i18n from '@/utils/i18n'
import GreenOperationStatusLifecycle from './GreenOperationStatusLifecycle.vue'
import { useGreenOperation } from './hook'

export default {
  components: {
    HKLGrayHint,
    HKLStatusBadge,
    GreenOperationStatusLifecycle,
  },
  props: {
    canViewHistoricalRecords: {
      type: Boolean,
      default: false,
    },
  },
  setup () {
    const userStore = useStoreGetters('user', ['isTenant'])
    const { data: greenOperation } = useGreenOperation()
    const { open, modal } = useRefModal()
    const status = computed(() => unref(greenOperation).status)
    const statusDisplay = computed(() => {
      return unref(status) ? i18n.t(`status.${unref(status).toLowerCase()}`) : i18n.t('emptyValue')
    })
    const expiredDateDisplay = computed(() => {
      const expiredDate = unref(greenOperation).expiredDate
      return expiredDate ? dateUtil.formatByLongDate(expiredDate, 'L') : i18n.t('emptyValue')
    })
    const isStarted = computed(() => !!unref(status))

    return {
      ...userStore,
      modal,
      status,
      isStarted,
      expiryDateDisplay: expiredDateDisplay,
      currentStatus: computed(() => {
        return unref(statusDisplay)
      }),
      openLifecycle: () => {
        if (!unref(isStarted)) return false
        open()
      },
    }
  },
}
</script>

<style lang="scss" scoped>
.green-operation__status {
  &-actions {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 10px;
  }
  &-info {
    margin-bottom: 30px;
    width: 100%;
    background-color: #F2F6F8;
    padding: 15px;

    label {
      margin-top: 0;
    }
  }
  &-value {
    display: inline-block;
  }
  .tenant-hint {
    margin-bottom: 20px;
  }
  .green-operation__history-link {
    cursor: pointer;
    font-weight: bold;
    text-decoration: underline;
  }
}
</style>
